<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Group'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="teamName"
              [form]="form.controls.teamName"
              [label]="'Group Name'"
              [errorMessage]="'Please enter the first name of the group.'"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          @if (parentTeamItems?.length > 0) {
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/information-circle.svg'"
                [label]="'Parent Group (optional)'"
                [items]="parentTeamItems"
                [form]="form.controls.parentTeam"
                formControlName="parentTeam" />
            </tidy-row>
          }
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Add Group'"
          [action]="boundAddTeam"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
